import { render, staticRenderFns } from "./user-buchung.vue?vue&type=template&id=4d46c140&"
import script from "./user-buchung.vue?vue&type=script&lang=js&"
export * from "./user-buchung.vue?vue&type=script&lang=js&"
import style0 from "./user-buchung.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports